import { FC, useContext, useState } from "react";
import Header from "../SubComponents/Header";
import {
  Typography,
  Grid,
  Container,
  Box,
  useMediaQuery,
  Button,
} from "@material-ui/core";
import { useTheme } from "@material-ui/core";
import newimageauth from "../../assets/images/authbanner.png";
import AuthImage from "../SubComponents/AuthImage";
import useStyles from "../Styles/AuthStyles";
import ExpireLink from "../../assets/images/ExpireLinkIcon.svg";
import AuthContext from "../../store/Auth/AuthContext";
import { useParams, useHistory } from "react-router-dom";
import { CountdownCircleTimer } from "react-countdown-circle-timer";

const ValidateEmail: FC = () => {
  const classes = useStyles();
  const theme = useTheme();
  const isActive = useMediaQuery(theme.breakpoints.down("sm"));
  const history = useHistory();
  let { email }: any = useParams();
  const { isAuth, ResendLinkRegister } = useContext<any>(AuthContext);
  const [disableToResend, setDisableToResend] = useState(true);

  if (isAuth) {
    history.push("/deals");
  }

  const handleResend = () => {
    ResendLinkRegister(email);
    setDisableToResend(true);
  };

  const Expire = () => {
    return (
      <img src={ExpireLink} className="img-fluid imageAlign" alt="Gains" />
    );
  };
  return (
    <Box className={classes.authpages} component="section">
      <Header authPage />
      <>
        <Container fixed>
          <Grid container spacing={0}>
            <Grid className="borderleft" item md={5} sm={12}>
              <AuthImage image={newimageauth} />
            </Grid>
            <Grid className="borderleft  borderRight" item md={7} sm={12}>
              <Box
                className="validateEmailTextBox"
                pl={isActive ? 0 : 7}
                pr={isActive ? 0 : 7}
              >
                <Typography variant="h2" color="primary">
                  Validate
                  <Typography component="span" variant="h2" color="secondary">
                    {" "}
                    Your Email Address
                  </Typography>
                </Typography>

                <Typography variant="body1" className="fw-bold  ">
                  Your email validation is pending!
                  <Typography variant="body1" component="span">
                    {" "}
                    A confirmation link has been <br />
                    sent to
                  </Typography>
                  <Typography
                    variant="body1"
                    component="span"
                    className=" fw-bold "
                  >
                    {" "}
                    {email}
                  </Typography>
                  <Typography
                    variant="body1"
                    component="span"
                    className="fw-normal"
                  >
                    {" "}
                    to verify your email.
                  </Typography>
                </Typography>

                <Box mt={5} className="pt-0">
                  <Grid
                    container
                    alignItems="center"
                    spacing={isActive ? 3 : 2}
                  >
                    <Grid item lg={5} md={5} sm={4} xs={12}>
                      <Button
                        color="secondary"
                        variant="contained"
                        size="large"
                        onClick={handleResend}
                        disabled={disableToResend}
                      >
                        resend link
                        {disableToResend && (
                          <Box marginLeft={isActive ? "1.5rem" : ".75rem"}>
                            <CountdownCircleTimer
                              isPlaying
                              duration={60}
                              colors="#3eb8aa"
                              size={40}
                              isGrowing
                              strokeWidth={5}
                              rotation="counterclockwise"
                              onComplete={() => setDisableToResend(false)}
                            >
                              {({ remainingTime }) => {
                                return (
                                  <Typography variant="h4" color="primary">
                                    {remainingTime}
                                  </Typography>
                                );
                              }}
                            </CountdownCircleTimer>
                          </Box>
                        )}
                      </Button>
                    </Grid>

                    <Grid item lg={6} md={7} sm={6} xs={12}>
                      <Expire />
                      <Typography
                        variant="subtitle1"
                        color="secondary"
                        component="span"
                        className="fw-normal"
                      >
                        {" "}
                        This link will expire after 24 hours.
                      </Typography>
                    </Grid>
                  </Grid>
                </Box>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </>
    </Box>
  );
};

export default ValidateEmail;
